import GlobalMediaTypes from "../GlobalMediaTypes"
import { useQuery } from "react-query"
import { fetchCurrentMarket } from "api/markets"
import { Container } from "components/Page"

function MarketMediaTypes() {
  const { data: market } = useQuery("current-market", fetchCurrentMarket)
  return (
    <Container>
      <GlobalMediaTypes configScope="MARKET" configOwnerId={market?.id} />
    </Container>
  )
}

export default MarketMediaTypes
